import { ApiRoute, HttpMethod } from '../common/api/routes';
import { SignedUrl, Url } from '../common/lang/web';

export const UrlSigningApi = {
    signUrls: new ApiRoute<{ urls: SignedUrl[] }, void, void, { urls: Url[] }>(HttpMethod.Get, path =>
        path.literal('signUrls'),
    ),
};
